<template>
  <ValidationObserver ref='validationObserver'>
    <a v-if="editing && !admin" href='#' @click="goTo({path: '/mf/home' })" class='back-button'> <font-awesome-icon title='Voltar' icon="fa-arrow-left" /> </a>
    <a v-if="admin" href='#' @click="goTo({path: '/doadores' })" class='back-button'> <font-awesome-icon title='Voltar' icon="fa-arrow-left" /> </a>
    <div id="dados-pessoas-form">
      <div class="new-form-row">
        <h3 class="new-form-legend">Dados pessoais</h3>
      </div>

      <div class="new-form-row">
        <validation-provider class="new-form-validation" rules="required|oneOf:2,1" v-slot="{ errors }">
          <div class="new-form-group-radio">
            <div class="new-form-radio">
              <input id="person-2" type="radio" data-cy="pessoa" name="person" v-model="form.person" value="2">
              <label for="person-2">Pessoa Física</label>
            </div>
            <div class="new-form-radio">
              <input id="person-1" type="radio" data-cy="pessoa" name="person" v-model="form.person" value="1">
              <label for="person-1">Pessoa Jurídica</label>
            </div>
          </div>
          <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required"
          v-slot="{ errors }">
            <div class="new-form-input">
              <input
                name="name"
                v-model="form.name"
                type="text"
                :placeholder="form.person == '2' ? 'Primeiro nome' : 'Razão social'"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required"
          v-slot="{ errors }">
            <div class="new-form-input">
              <input
                name="last_name"
                v-model="form.last_name"
                type="text"
                :placeholder="form.person == '2' ? 'Último nome' : 'Nome fantasia'"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required|email"
          v-slot="{ errors }"
          vid="email"
          >

            <div class="new-form-input">
              <input
                name="email"
                v-model="form.email"
                type="text"
                placeholder="E-mail"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row">
        <validation-provider
          :rules="'required|' + (form.person == '2' ? 'cpf':'cnpj')"
          v-slot="{ errors }" vid="document" >
            <div class="new-form-input">
              <input
                name="document"
                v-model="form.document"
                type="text"
                :placeholder="form.person == '2'?'CPF':'CNPJ'"
                v-mask="form.person == '2' ? '###.###.###-##' : '###.###.###/####-##' "
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row">
        <validation-provider
          rules="required"
          v-slot="{ errors }">
            <div class="new-form-input">
              <input
                name="tel_cel"
                v-model="form.tel_cel"
                type="text"
                placeholder="Telefone celular"
                v-mask="'(##) # ####-####'"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row" v-if="!this.editing && !this.admin">
        <validation-provider
          rules="required"
          v-slot="{ errors }" vid="password">
            <div class="new-form-input">
              <input
                name="password"
                v-model="form.password"
                type="password"
                placeholder="Senha"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

      <div class="new-form-row" v-if="!this.editing && !this.admin">
        <validation-provider
          rules="required"
          v-slot="{ errors }">
            <div class="new-form-input">
              <input
                name="password_confirmation"
                v-model="form.password_confirmation"
                type="password"
                placeholder="Confirmar senha"
              >
            </div>
            <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
        </validation-provider>
      </div>

    </div>

    <div class="new-form-controls" v-if="this.editing">
      <div class="new-form-control">
        <button
          @click="validForm"
          class="new-form-button new-form-button-primary"
        > Atualizar
        </button>
      </div>
    </div>

    <div class="new-form-controls" v-if="this.admin && !this.editing">
      <div class="new-form-control">
        <button
          @click="validForm"
          class="new-form-button new-form-button-primary"
        > Criar
        </button>
      </div>
    </div>

  <div class="new-form-loading" v-if="this.loading"></div>
  </ValidationObserver>
</template>

<script>
import { setupAxios } from '../../setupAxios';
import { getCurrentUser, updateDonator, createDonatorFromAdmin, updateDonatorByAdmin } from '../../apiClient';
import { querySearch } from '../../../../helpers'

export default {
  name: 'PersonalDataForm',
  props: {
    editing: { type: Boolean, default: false },
    admin: { type: Boolean, default: false },
    donator: undefined
  },
  data: function () {
    return {
      loading: false,
      form: {
        person: '2',
        name: '',
        last_name: '',
        email: '',
        document: '',
        tel_cel: '',
        password: '',
        password_confirmation: '',
        source: '',
      }
    };
  },
  async mounted () {
    const source = querySearch("source");

    if (source) {
      this.form.source = source;
    }

    this.axios = setupAxios(this.getValidationObserver());
    if (this.editing) {
      this.donator = this.donator ? this.donator : await getCurrentUser(this.axios);
      this.setFormWithDonatorData(this.donator);
    }
  },
  methods: {
    validForm: async function () {
      this.setLoading(true);
      const isValid = await (this.$refs.validationObserver.validate()) && await this.submit();
      this.setLoading(false);
      return isValid;
    },
    submit: async function () {
      if (this.editing) {
        return this.edit();
      } else if (this.admin) {
        return this.createByAdmin();
      } else {
        return this.create();
      }
    },
    getValidationObserver () {
      return this.$refs.validationObserver;
    },
    async create () {
      const res = await this.axios.post('/api/v2/donator', { ...this.form });
      if (res) {
        const { expires, token } = res.data;
        // @todo padronizar
        localStorage.setItem('token', token);
        localStorage.setItem('token_creation_ts', new Date().getTime());
        localStorage.setItem('ttl', expires);
        return true;
      }
    },
    async createByAdmin () {
      const res = await createDonatorFromAdmin(this.axios, { ...this.form });
      if (res) {
        alert('Doador Criado.');
        this.$router.push({ name: 'doadores' });
      }
    },
    async edit () {
      const donatorWasEdited = (
        this.form.name.replace(/[^0-9a-z]/gi, '') !== this.donator.name ||
        this.form.last_name.replace(/[^0-9a-z]/gi, '') !== this.donator.last_name ||
        this.form.email.replace(/[^0-9a-z]/gi, '') !== this.donator.email ||
        this.form.document.replace(/[^0-9a-z]/gi, '') !== this.donator.document ||
        this.form.tel_cel.replace(/[^0-9a-z]/gi, '') !== this.donator.tel_cel
      );
      if (donatorWasEdited) {
        const res = this.admin ? await updateDonatorByAdmin(this.axios, this.donator.id, { ...this.form }) : await updateDonator(this.axios, { ...this.form });

        if (res) {
          alert('Dados atualizados!!!');
        }
      }
    },
    setLoading (isLoading) {
      if (this.editing || this.admin) {
        this.loading = isLoading;
      } else {
        this.$parent.setLoading(isLoading);
      }
    },
    setFormWithDonatorData (donator) {
      this.form.name = donator.name;
      this.form.last_name = donator.last_name;
      this.form.email = donator.email;
      this.form.document = donator.document;
      this.form.tel_cel = donator.tel_cel;
    },
    goTo (params) {
      this.$router.push({ path: params.path });
    }

  }
};
</script>
